import * as lpTextBlocStyles from "./lpTextStyles.module.scss";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import RichTextContentful from "../RichTextContentful";
import "./LPText.scss";

function LPText({ data, showAnchor = false, showTitle = false, showSEOLinks = false }) {
  const { backgroundColor, color, content, textAlign } = data;

  return (
    data && (
      <div
        className={`${lpTextBlocStyles.container} id-${data.contentful_id}`}
        style={{ backgroundColor, color, textAlign: textAlign[0] }}
      >
        {showTitle && <h2>{data.title}</h2>}
        {showAnchor && (
          <span
            id={`${data.title
              .toLowerCase()
              .replace(/[^a-z0-9]+/g, "-")
              .replace(/^-+|-+$/g, "")}`}
            className={lpTextBlocStyles.anchor}
          >
            &nbsp;
          </span>
        )}
        <RichTextContentful
          input={content?.raw}
          prefixClassName="lptext"
          showSEOLinks={showSEOLinks}
        />
      </div>
    )
  );
}

export default withALErrorBoundary({
  name: "LPText",
  priority: "P3",
})(LPText);
